import { Scalars } from '@graphql/types.generated';

// TODO: rewrite to round any digit, not just first one
// we can even implement it into toVNDShort and toVND functions
export function roundFirstDigit(num: number) {
  return Math.round(num / 10) * 10;
}

export const toVND = (value: string | number, currency = 'VND'): string | number => {
  if (!value && value !== 0) return value;
  const rounded = parseFloat(String(value));

  return rounded.toLocaleString('it-IT', { style: 'currency', currency });
};

const formatByIntl = (options: Intl.DateTimeFormatOptions) => (isoString: Scalars['ISO8601DateTime']) =>
  typeof isoString === 'string' ? new Intl.DateTimeFormat('vi-VN', options).format(new Date(isoString)) : '';

export const formatDateTime = formatByIntl({
  year: '2-digit',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

export const formatDate = formatByIntl({
  year: '2-digit',
  month: '2-digit',
  day: '2-digit',
});

export const formatTime = formatByIntl({
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

export const dateTimeNoSecond = formatByIntl({
  year: '2-digit',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

// For returning positive value only
export const toVNDShort = (amount: number): string => {
  if (!amount && amount !== 0) return '';

  const formatter = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  });

  const absoluteAmount = Math.abs(amount);

  return formatter.format(absoluteAmount);
};

export const toUSDShort = (amount: number): string => {
  if (!amount && amount !== 0) return '';

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const absoluteAmount = Math.abs(amount);

  return formatter.format(absoluteAmount);
};

export const toCurrencyShort = (value: number, unit = 'VND'): string => {
  return unit.toLowerCase() === 'vnd' ? toVNDShort(value) : toUSDShort(value);
};

// For returning both positive and negative value
export const toVNDShortWithNegative = (amount: number): string => {
  if (!amount && amount !== 0) return '';

  const formatter = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  });

  return formatter.format(amount);
};

export function toNumberFormat(num: number) {
  if (typeof num !== 'number') return 0;
  return Math.abs(num).toLocaleString('vi-VN');
}

/**
 * This exists for trying to serialize the value back to JSON.
 * If it cannot serialize it, then it was a string value given.
 *
 * @param value the value you wish to try to parse
 */
export function tryParse(value: string) {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

export const toNumberWithComma = (value: number | string = 0): string => {
  if (!value && value !== 0) return '';
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const toNumberWithoutComma = (value = '0'): string => {
  return value.replace(/\$\s?|(,*)/g, '');
};

export const removeTones = (str: string) => {
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // Huyền sắc hỏi ngã nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // Â, Ê, Ă, Ơ, Ư
  return str;
};

export function truncateText(text: string, maxLength: number): string {
  if (text.length > maxLength) {
    return `${text.substring(0, maxLength)}...`;
  }

  return text;
}
